export default __webpack_public_path__ + "static/media/hyosung.fe718384.png";